<template>
<span>
  <v-file-input
    chips
    small
    multiple
    :label="label"
    v-model="mFiles"
  >
  </v-file-input>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
      <fileup-head
        :brief="brief"
      >
      </fileup-head>
      </thead>
      <tbody>
        <fileup-row v-for="(thumb, index) in thumbData"
          :key="index"
          :thumb="thumb"
          :brief=brief
        >
        </fileup-row>
      </tbody>
    </template>
  </v-simple-table>
</span>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import FileupRow from '@/components/Fileuprow'
import FileupHead from '@/components/Fileuphead'
import filesize from 'filesize'
export default {
  data: () => ({
    mFiles: []
  }),
  components: {
    'fileup-row': FileupRow,
    'fileup-head': FileupHead
  },
  props: {
    label: String,
    brief: Boolean
  },
  watch: {
    mFiles () {
      this.actionThumbs({files: this.mFiles})
    }
  },
  computed: {
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  methods: {
    filesize (size) {
      return filesize(size)
    },
    ...mapMutations(vxMaps.mutations),
    ...mapActions(vxMaps.actions)
  }
}
</script>
